import React from "react";

import { Button, Space } from "antd";

export const ColumnsMappingCashFlow = [
  {
    title: "Cliente",
    dataIndex: "client",
    textWrap: "word-break",
    ellipsis: true,
  },

  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Space size="middle">
          <a onClick={() => row.disable(row)} type="primary">
            Desativar
          </a>
        </Space>
      );
    },
  },
];
export const ColumnsMappingCashFlowExpend = [
  {
    title: "Nível 1",
    dataIndex: "name",
  },
  {
    title: "Ordem",
    dataIndex: "order",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <div>
          <Button
            onClick={() => row.edit(row)}
            type="primary"
            className="button-action"
          >
            Editar
          </Button>
          <Button
            onClick={() => row.disable(row)}
            type="primary"
            className="button-disable"
          >
            Desativar
          </Button>
        </div>
      );
    },
  },
];
export const ColumnsMappingCashFlowCategoryExpend = [
  {
    title: "Nível 2",
    dataIndex: "category",
  },
  {
    title: "Código",
    dataIndex: "categoryCode",
  },
];

export const ColumnsMappingCashFlowCsv = [
  {
    label: "Cliente",
    key: "client",
  },
  {
    label: "Grupo",
    key: "name",
  },
  {
    label: "Ordem",
    key: "order",
  },
  {
    label: "Categoria",
    key: "category",
  },
  {
    label: "Código Categoria",
    key: "categoryCode",
  },
  {
    label: "Totalizador",
    key: "isTotalString",
  },
];
